<script lang="ts" setup>
import PageHeader from '@/components/global/page-header/PageHeader.vue'
import MergeForm from '@/components/features/yarns/MergeForm.vue'
import { useRouter } from 'vue-router'
import { useMergeForm } from '@/composables/useMergeForm'
import { addYarn } from '@/api/yarns'
import {computed, onMounted, ref, toRef, watch} from 'vue'
import type { ErrorResponse } from '@/types/error-types'

const router = useRouter()
const { values, loading, handleSubmit, setErrors, showToast, setFieldValue } = useMergeForm('add')
const totalCostAmount = computed(() => {
  return (values.totalKgOrdered && values.costPerKgAmount) ? values.totalKgOrdered * values.costPerKgAmount : 0;
})

const totalCostCurrency = computed({
  get: () => values.costPerKgCurrency,
  set: (newCurrency) => values.totalCostCurrency = newCurrency
});

const defaultCurrency = ref(values.costPerKgCurrency);
const submit = handleSubmit(async () => {
  loading.value = true
  const formValues = {
  ...values,
  totalCostAmount: totalCostAmount.value,
  totalCostCurrency: totalCostCurrency.value,
  dateOrdered: values.dateOrdered,
  dateExpected: values.dateExpected,
  createdAt: new Date().toISOString(),
  }

  addYarn(formValues)
    .then(() => {
      loading.value = false
      showToast('success', 'Yarn Added!', 'You have successfully added a new yarn.')
      router.push('/yarns')
    })
    .catch((error) => {
      console.error('Failed to add yarn:', error)
      loading.value = false
      showToast('error', 'An error occurred!', 'Unable to add yarn.')
    })
},
(errors: Record<string, string>) => {
  loading.value = false

  const errorObjects = Object.entries(errors.errors).map(([field, message]) => ({
    code: field,
    description: message,
  }))

  if(errorObjects.length > 0) {
    const firstError = errorObjects[0]
    const errorMessage = ` ${firstError.description}`
    showToast('error', 'Validation Error', errorMessage)
    return
  }
}
)

onMounted(() => {
 defaultCurrency.value = 0
 setFieldValue('costPerKgCurrency', defaultCurrency.value)
});

</script>

<template>
  <PageHeader
    title="Add New Merge"
    buttonText="Save Merge"
    buttonIcon="material-symbols:save"
    :buttonClick="submit"
    :loading="loading"
  />

  <div class="bg-white rounded-xl">
    <MergeForm :type="'add'" v-model:values="values" :onSubmit="submit" :setErrors="setErrors" />
  </div>
</template>
